import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { truncateImageTitle } from "client/utils/truncateImageTitle";
import { CloseIcon } from "components/common/Icons/CloseIcon";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { useState } from "react";
import type { CompressImage } from "store/features/compress/types";

interface TitleProps {
    image: CompressImage;
    index: number;
    handleDelete: (imageId: string) => void;
}

export const Title = ({ image, handleDelete, index }: TitleProps) => {
    return (
        <div className="flex justify-between items-center mb-auto">
            <div className="whitespace-nowrap text-sm font-bold">
                <ToolTip
                    text={image.title}
                    position={{
                        y: "down",
                    }}
                >
                    <div
                        className="hidden sm:block lg:hidden xl:block"
                        data-testid={`preview-image-${index}-mobile-title`}
                    >
                        {truncateImageTitle(image.title, 8)}
                    </div>
                    <div className="sm:hidden lg:block xl:hidden" data-testid={`preview-image-${index}-desktop-title`}>
                        {truncateImageTitle(image.title, 3)}
                    </div>
                </ToolTip>
            </div>
            <Close image={image} handleDelete={handleDelete} index={index} />
        </div>
    );
};

const Close = ({ image, handleDelete, index }: TitleProps) => {
    return (
        <ToolTip
            text={capitalize(translateFunc("remove-image"))}
            position={{
                y: "down",
            }}
        >
            <div
                className="group cursor-pointer bg-gray-50 dark:bg-darkSurface-200 p-1 rounded-full flex-grow-0 flex-shrink-0"
                onClick={(e) => {
                    e.stopPropagation();
                    handleDelete(image.id);
                }}
                data-testid={`preview-image-${index}-close-icon`}
            >
                <CloseIcon width={10} height={10} strokeWidth={3} className="stroke-black dark:stroke-white" />
            </div>
        </ToolTip>
    );
};
